import React from "react";
import OnePanel from "./OnePanel";
import Styled, { LineBreak } from "./styles";
import styledComponents from 'styled-components';

const Name = styledComponents.span`
  color: #ff5252;
  font-weight: bold;
`;

const OpportunityEconomyIndustry = props => (
  <OnePanel title="THE OPPORTUNITY">
    Anna is a recent business graduate. She had two successful internships during her junior and senior years and had
    a return offer from the company that she interned during her senior year. However, she and three of her close friends
    were not ready to assume the role of "employee"; these five ambitious graduates wanted to pursue entrepreneurial aspirations
    first. The Z team, as they called themselves, included, Anna, Bob, William, Teresa ). They agreed to explore start-up opportunities
    for six months and at the end of six months if they can’t identify and agree on an opportunity then they would pursue traditional
    career paths.One afternoon, as usual Anna was sitting at her favorite coffeeshop, combing through webpages, hoping to uncover a
    business opportunity. An article in the Daily Californian caught her eyes and attention.
    <LineBreak />
    Filled with excitement, Anna jumped out of her seat, and dashed towards Bancroft way. She was eager to meet the rest of the Z team
    to share the exciting news.
    <LineBreak />
    <Name>Anna yelled</Name>, "Hey guys! I have some great news to tell you!"
    <LineBreak />
    <Name>Bob responded</Name>, "What is it?"
    <LineBreak />
    <Name>Anna</Name> pointed at a Daily Californian article and said, "we have a great opportunity in the image sensor business!"
    <LineBreak />
    Bob and William looked at each other in confusion, and William responded, "who cares about image sensors!?!" and returned to taking selfies.
    <LineBreak />
    <Name>Anna responded</Name>, "apparently, many do and there’s an opportunity for us to capture value in this market. Shall we do some research and then make a decision?"
    <LineBreak />
    "Informed decisions are always good" Teresa responded with a wink.
    <LineBreak count={3} />
    <Styled.Title>THE ECONOMY</Styled.Title>
    During this time, the U.S economy was still in its expansionary phase for more than 8 years, which was unusual. Some analysts suspected that
    the economic cycle would shift towards recession. However, conflicting data such as the low inflation rate suggested otherwise.
    To compound that, there was a new president with a new fiscal policy and with plans to nominate a new Federal Reserve Chairman.
    Therefore, the level of uncertainty with the Fed’s monetary policy was high. It was unclear if the Fed would remain dovish.
    <LineBreak count={3} />
    <Styled.Title>THE INDUSTRY</Styled.Title>
    The industry is driven heavily by demand from smartphone manufacturers, but is expected to expand further due to the growing
    demand from the automotive, healthcare, and surveillance space.
    <LineBreak />
    Bob, Anna’s friend, called his buddy Tom, an expert in the semiconductor industry.
    <LineBreak />
    <Name>Bob</Name>: "Hey Tom, this market is huge. How do we play in this game?"
    <LineBreak />
    <Name>Tom</Name>: "This game?? It's not a game, it's a billion dollar market."
    <LineBreak />
    <Name>Bob</Name>: "All markets are games to play. It’s a competition right? With players? Rules? Uncertainty? Goals?"<br />
    <Name>Tom</Name>: "What's the goal?"
    <LineBreak />
    <Name>Bob</Name>: "Capturing market share of course!"
    <LineBreak />
    <Name>Tom</Name>: "Are you sure about that? Anyways, in this 'game', you have to pay to play."
    <LineBreak />
    <Name>Bob</Name>: "How much, a few millions?"
    <LineBreak />
    <Name>Tom</Name>: "How about a billion dollars...and that’s just to buy the facility and production line. High barriers to entry my friend."
    <LineBreak />
    <Name>Bob</Name>: "I'm no longer enjoying this call Tom, speak to you later."
    <LineBreak />
    Digital image sensors are silicon microchips that are engineered to operate in different ways. The engineering involved in these circuits is
    very complex; so are the techniques used to manufacture these microchips. Integrated circuits are manufactured in semiconductor fabrication
    plants (commonly called fabs; sometimes foundry). The central part of a fab is a clean room, which is very expensive to build and maintain.
    Fabs also require very expensive equipment, and can easily cost hundreds of millions of dollars.
    <LineBreak />
    In addition to the high fab costs, constant new technologies create shorter product life cycles in this industry. Another challenge had been
    the low prices, especially in the case of mobile phone image sensors. Therefore, historically, the image sensor manufacturers had to be efficient,
    adapt to technological changes, and customer-centric to make a profit. Image sensors required by the automobile industry require higher quality
    than the mobile phone industry, but those sensors are priced high and have higher profit margins.
  </OnePanel>
);

export default OpportunityEconomyIndustry;



// WEBPACK FOOTER //
// ./src/components/bcase/OpportunityEconomyIndustry.js